import 'mapbox-gl/dist/mapbox-gl.css';
import Map, { Marker, Source, Layer } from 'react-map-gl';
import React, { useState, useEffect, useCallback } from 'react';
import { Box, IconButton, Stack, Typography, useTheme } from '@mui/material';

import DrawControl from './DrawControl';
import ControlPanel from './ControlPanel';

import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import MyLocationRoundedIcon from '@mui/icons-material/MyLocationRounded';
import HighlightAltRoundedIcon from '@mui/icons-material/HighlightAltRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';

import center from '@turf/center';
import { mapboxAccessToken } from 'config';

export default function MapDrawer({ selected = [], regions = [], onDrawComplete = (data) => {} }) {
  const theme = useTheme();
  const [draw, setDraw] = useState(false);
  const [mode, setMode] = useState('draw_polygon');
  const [features, setFeatures] = useState();
  const [markers, setMarkers] = useState([]);

  const [marker, setMarker] = useState({
    longitude: 51.666,
    latitude: 32.6539,
  });

  const layerStyle = {
    // type: 'circle',
    // paint: {
    //   'circle-radius': 10,
    //   'circle-color': '#007cbf',
    //   'fill-opacity': 1,
    //   'fill-antialias': true,
    //   'fill-color': theme.palette.primary.light,
    //   'fill-outline-color': theme.palette.primary.dark,
    // },
    type: 'fill',
    visibility: 'visible',
    paint: {
      'fill-opacity': 0.2,
      'fill-antialias': true,
      'fill-color': theme.palette.primary.light,
      'fill-outline-color': theme.palette.primary.dark,
    },
  };

  const onDraw = () => {
    setDraw(true);
  };

  const onDelete = () => {
    setDraw(false);
    onDrawComplete([]);
  };

  const onUpdate = useCallback((e) => {
    const coords = e.features[0]?.geometry.coordinates[0];
    const modifiedCoords = coords.map((point) => point.join(' '));
    onDrawComplete(modifiedCoords);
    // setFeatures((currFeatures) => {
    //   const newFeatures = { ...currFeatures };
    //   for (const f of e.features) {
    //     newFeatures[f.id] = f;
    //   }
    //   return newFeatures;
    // });
  }, []);

  // const changeDrawingMode = () => {
  //   setMode('draw_point');
  //   setMode('draw_line_string');
  //   setMode('draw.delete');
  //   drawRef && drawRef.current.draw.changeMode('draw_polygon');
  // };

  const modifyRegions = (regions, selected) => {
    const modifiedSelected = selected.map((item) => item?.id);
    const modifiedRegions =
      modifiedSelected.length > 0 ? regions.filter((item) => modifiedSelected.includes(item.id)) : regions;
    if (modifiedRegions.length > 0) {
      let features = [];
      let markers = [];
      modifiedRegions.map((region) => {
        let coordinates = region?.area
          ? region?.area
              .match(/\((.*)\)/)
              .pop()
              .split(',')
              .map((region) => region.split(' ').map((val) => parseFloat(val)))
          : [];
        let modifiedCenter = center({
          type: 'Polygon',
          coordinates: [coordinates],
        });
        markers.push({
          title: region?.title,
          latitude: modifiedCenter?.geometry.coordinates[1],
          longitude: modifiedCenter?.geometry.coordinates[0],
        });
        features.push({
          type: 'Feature',
          properties: {
            title: region?.title,
          },
          geometry: {
            type: 'Polygon',
            coordinates: [coordinates],
          },
        });
        return;
      });
      setMarkers(markers);
      setFeatures({
        features,
        type: 'FeatureCollection',
      });
      return;
    }
  };

  useEffect(() => {
    modifyRegions(regions, selected);
  }, [regions, selected]);

  return (
    <Stack
      minHeight={{ xs: 200, sm: 380, lg: 420 }}
      top={64}
      zIndex={1}
      width="100%"
      position="sticky"
      overflow="hidden"
      bgcolor="transparent"
      borderRadius={2}
    >
      <Map
        initialViewState={{
          zoom: 12,
          latitude: marker.latitude,
          longitude: marker.longitude,
        }}
        style={{ width: '100%', height: '100%', position: 'relative' }}
        mapStyle="/assets/map/green-gray.json"
        mapboxAccessToken={mapboxAccessToken}
      >
        <Stack
          alignItems="center"
          direction="row"
          position="absolute"
          bgcolor="action.selected"
          borderRadius={2}
          p={1}
          bottom={4}
          right="50%"
          sx={{
            transform: 'translateX(50%)',
          }}
          columnGap={0.5}
        >
          <IconButton size="small" color="secondary">
            <MyLocationRoundedIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" color="primary" onClick={onDraw}>
            <HighlightAltRoundedIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={onDelete}>
            <DeleteOutlineRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
        {draw && (
          <DrawControl
            position="top-right"
            displayControlsDefault={false}
            controls={{
              polygon: true,
              trash: false,
            }}
            defaultMode={mode}
            onCreate={onUpdate}
            onUpdate={onUpdate}
          />
        )}
        {features && (
          <Source id="regions" data={features} type="geojson">
            <Layer {...layerStyle} />
          </Source>
        )}
        {markers.map(({ title, latitude, longitude }, i) => (
          <Marker key={i} longitude={longitude} latitude={latitude} anchor="center">
            <Box p={0.5} bgcolor="action.hover" borderRadius={1}>
              <Typography color="primary.dark" variant="subtitle1" fontSize={16}>
                {title}
              </Typography>
            </Box>
          </Marker>
        ))}
        <Marker longitude={marker.longitude} latitude={marker.latitude} anchor="center" draggable>
          <PlaceRoundedIcon color="primary" />
        </Marker>
        {/* <ControlPanel polygons={Object.values(features)} /> */}
      </Map>
    </Stack>
  );
}
